import ReactDOM from 'react-dom/client';
import App from './App';
import "./styles/global.css";
import "./styles/responsive.css";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <App />
);
